import ProfileSidebar from "./components/ProfileSidebar";
import Header from "../../components/layout/Header";
import Achievements from "./components/Achievements";
import { Helmet } from "react-helmet";

export default function Profile() {

  return (
    <div className="pageStandard">
      <Helmet>
        <title>min side | matly</title>
      </Helmet>
      <Header />
      <div className="contentRow">

        <ProfileSidebar />

        <Achievements />
      </div>
    </div>
  );
}